export default "__VITE_ASSET__Cgl0as4P__"